import { render, staticRenderFns } from "./DepartUserList.vue?vue&type=template&id=6183a498&scoped=true"
import script from "./DepartUserList.vue?vue&type=script&lang=js"
export * from "./DepartUserList.vue?vue&type=script&lang=js"
import style0 from "./DepartUserList.vue?vue&type=style&index=0&id=6183a498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6183a498",
  null
  
)

export default component.exports